import styled from "styled-components";
import { Modal, Upload, Input, Button, Select } from "antd";
import { IoDocumentOutline, IoCloudUploadOutline } from "react-icons/io5";
import { FaRegTrashAlt } from "react-icons/fa";

const { Dragger } = Upload;

export const FlowCardContainer = styled.div`
  display: flex;
  width: auto;
  height: 156px;
  border: 1px solid rgba(235, 235, 240, 1);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  padding-inline: 16px;
  justify-content: center;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: rgba(235, 235, 240, 1);
  margin-top: 8px;
`;

export const HeaderCard = styled.div`
  height: 77px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CardTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  line-height: 120%;
  color: rgba(58, 58, 60, 1);
  font-family: "Open Sans";
  margin-top: 20px;
  max-width: 300px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  padding-right: 10px;
  height: 40px;
`;

export const CardDate = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 100%;
  color: rgba(108, 108, 108, 1);
  font-family: "Open Sans";
  display: flex;
  white-space: nowrap;
  margin: 0;
`;

export const FlowViewButton = styled.div`
  height: 77px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const OpenButton = styled.div`
  font-family: Open Sans;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  width: fit-content;
  text-decoration: underline;
  text-decoration-style: solid;
  color: rgba(17, 167, 217, 1);
  cursor: pointer;
  align-items: center;
  display: flex;
  gap: 8px;
`;

export const InactiveInfo = styled.div`
  font-family: Open Sans;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  width: fit-content;
  font-style: italic;
  text-decoration-style: solid;
  color: #fff;
  background-color: #666666;
  border-radius: 8px;
  padding: 6px;
  align-items: center;
  display: flex;
  gap: 8px;
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContainer = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  min-width: 500px;
  max-width: 750px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
`;

export const ModalContent = styled.div`
  padding: 32px;
  text-align: center;
`;

export const DetailsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: flex-start;
  padding-bottom: 5px;
`;

export const PackageBadge = styled.span`
  display: flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 12px;
  background-color: #eef2ff;
  color: #12a7d9;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  gap: 4px;
  font-family: "Open Sans", sans-serif;
  white-space: nowrap;
`;

export const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 700;
  color: #333;
  margin-bottom: 16px;
  line-height: 22px;
  font-family: "Open Sans", sans-serif;
`;

export const ModalDescription = styled.p`
  font-size: 14px;
  color: #666;
  margin-bottom: 32px;
  line-height: 22px;
  font-weight: 400;
  font-family: "Open Sans", sans-serif;
`;

export const ModalSpanDescription = styled.p`
  font-size: 14px;
  color: #333;
  line-height: 22px;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
`;

export const ModalButtonsContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  align-items: center;
`;

export const ModalCancelButton = styled.button`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  background: #e2e8f0;
  color: #002244;
  border: 1px solid #e2e8f0;
  border-radius: 5px;
  padding: 8px 24px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 100px;
  line-height: 1.5;

  &:hover:not(:disabled) {
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ModalConfirmButton = styled.button`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  background: #991b1b;
  color: white;
  border: 1px solid #991b1b;
  border-radius: 5px;
  padding: 8px 24px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 100px;

  &:hover:not(:disabled) {
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SendModal = styled(Modal)`
  .ant-modal-content {
    width: 498px;
    min-height: 464px;
    border-radius: 10px;
  }
  .ant-modal-footer {
    border-top: none;
    display: flex;
  }
`;

export const ModalTitle1 = styled.h1`
  width: 137;
  height: 32;

  font-family: Open Sans;
  font-weight: 700;
  font-style: Bold;
  font-size: 20px;
  line-height: 32px;
  color: rgba(68, 68, 68, 1);
`;

const UPLOADERS_SCROLL_MAX_HEIGHT = "440px";
const UPLOADERS_SCROLL_GAP = "16px";
const SCROLLBAR_WIDTH = "4px";
const SCROLLBAR_THUMB_COLOR = "#11a7d9";
const SCROLLBAR_TRACK_COLOR = "#fcfcfc";

export const UploadersScrollArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${UPLOADERS_SCROLL_GAP};
  max-height: ${UPLOADERS_SCROLL_MAX_HEIGHT};
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;

  ::-webkit-scrollbar {
    width: ${SCROLLBAR_WIDTH};
    height: 0;
    background-color: ${SCROLLBAR_TRACK_COLOR};
  }

  ::-webkit-scrollbar-thumb {
    background: ${SCROLLBAR_THUMB_COLOR};
    border-radius: 4px;
  }

  ::-webkit-scrollbar-horizontal {
    display: none;
  }
`;

export const ModalBtnsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 10px;
  height: 35px;
`;

export const ModalActionBtns = styled.button`
  width: 221px;
  height: 100%;
  border-radius: 5px;
  font-family: Open Sans;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0px 0.75px 1.5px 0px rgba(16, 24, 40, 0.05);
  background: ${({ $isCancel }) => ($isCancel ? "#C9C9C9" : "#002244")};
  color: rgba(255, 255, 255, 1);
  border: none;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  }

  &:disabled {
    cursor: not-allowed;
    transform: none;
  }
`;
export const StyledDragger = styled(Dragger)`
  margin-top: 15px;
  background: rgba(255, 255, 255, 1) !important;
  width: 450px !important;
  height: 104px !important;
  border-radius: 10px !important;
  padding: 24px !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;

  border: 1px dashed rgba(0, 0, 0, 0.25) !important;
  opacity: 1;
  cursor: pointer;

  .ant-upload-drag-icon {
    font-size: 24px;
  }

  .ant-upload-text,
  .ant-upload-hint {
    margin: 0;
  }

  /* Estilo do preview dos arquivos selecionados */
  .ant-upload-list-item {
    background: #f5f5f5; /* cor de fundo do preview */
    border-radius: 8px; /* cantos arredondados */
    padding: 8px 12px;
    margin-top: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    border: 1px solid rgba(199, 201, 217, 1);
  }

  .ant-upload-list-item-name {
    font-size: 14px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 300px;
    border: 1px solid rgba(199, 201, 217, 1);
  }

  .ant-upload-list-item-actions {
    display: flex;
    gap: 8px;
    border: 1px solid rgba(199, 201, 217, 1);

    .anticon {
      font-size: 16px;
      color: #ff4d4f; /* cor do ícone de remover */
      cursor: pointer;
    }
  }
`;

export const UploadWrapper = styled.div`
  .ant-upload-drag {
    background: rgba(255, 255, 255, 1) !important;
    width: 450px !important;
    height: 104px !important;
    border-radius: 10px !important;
    padding: 24px !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border: 1px dashed rgba(0, 0, 0, 0.25) !important;
    cursor: pointer;
  }

  .ant-upload-disabled {
    cursor: not-allowed !important;
    opacity: 0.6;
  }
`;

export const DraggerText = styled.p`
  font-family: Open Sans;
  font-size: 14px;
  color: rgb(141, 150, 161));
  font-weight: 400;
  text-align: center;
  font-style: Regular;
  line-height: 150%;
  letter-spacing: 0%;
  vertical-align: middle;
`;

export const FileNameSpan = styled.span`
  display: inline-block;
  width: 80%;
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  margin-left: 10px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ClickHere = styled.span`
  color: rgba(17, 167, 217, 1); // cor diferente
  text-decoration: underline;
  font-weight: 600;
  margin-right: 5px;
`;

export const ObsContainer = styled.div`
  margin-top: 24px;
`;

export const ObsInput = styled(Input.TextArea)`
  width: 450px;
  height: 113px;
  font-size: 14px;
  outline: none;

  .ant-input,
  .ant-input-textarea,
  textarea {
    border-radius: 8px !important;
    resize: none;

    &::-webkit-scrollbar {
      width: 8px;
      border-radius: 12px;
      background: #f1f1f1;
    }
    &::-webkit-scrollbar-thumb {
      background: #bdbdbd;
      border-radius: 12px;
    }
    &::-webkit-scrollbar-corner {
      background: #f1f1f1;
      border-radius: 12px;
    }
  }
`;

export const FileItemContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  margin-top: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  background: transparent;
  width: 450px;
  height: 57px;

  &.disabled {
    pointer-events: none;
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
export const FileItemContent = styled.div`
  display: flex;
  align-items: center;
  width: 80%;
`;
export const FileIcon = styled(IoDocumentOutline)`
  cursor: pointer;
  color: rgba(17, 167, 217, 1);
  font-size: 18px;
`;

export const DeleteIcon = styled(FaRegTrashAlt)`
  cursor: pointer;
  color: red;
  font-size: 16px;
`;
export const UploadIcon = styled(IoCloudUploadOutline)`
  color: rgba(144, 161, 185, 1);
  font-size: 24px;
`;
export const ErrorText = styled.span`
  color: red;
  font-size: 12px;
  margin-top: 4px;
  display: block;
`;

export const ExtensionInformation = styled.p`
  color: #676f82;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-align: justify;
  text-justify: inter-word;
  margin: 0;
`;

export const NotesOptional = styled.span`
  color: #999999;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;

export const ContainerSelection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-start;
  margin-top: 15px;
  margin-bottom: 15px;
  width: 100%;
  white-space: nowrap;
s
`;

export const DocumentSelect = styled(Select)`
  width: 100%;

  .ant-select-selector {
    border-radius: 8px !important;
    padding: 0 12px !important;
    display: flex;
    align-items: center;
  }
`;

export const DownloadTemplateButton = styled(Button)`
  width: 100%;
  height: 34px;
  margin-top: 10px;
  margin-bottom: 15px;
  background-color: rgba(226, 232, 240, 1);
  color: #676f82;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  gap: 8px;
  font-family: Open Sans;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: rgba(226, 232, 240, 1);
    border-color: #d9d9d9;
    color: #676f82;
    transform: translateY(-2px);
  }
`;

export const ErrorMessage = styled.div`
  color: red;
  margin-top: -10px;
  margin-bottom: 10px;
  font-size: 13px;
  text-align: right;
`;

const PRIMARY_BG = "rgba(0, 34, 68, 1)";
const DANGER_BG = "#991B1B";
const BACK_BUTTON_BG = "rgba(226, 232, 240, 1)";
const BACK_BUTTON_COLOR = "rgba(0, 34, 68, 1)";

export const StyledReasonModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
    overflow: hidden;
  }

  .ant-modal-header,
  .ant-modal-body,
  .ant-modal-footer {
    padding: 16px 24px;
  }

  .ant-modal-header {
    margin-bottom: 0;
  }

  .ant-modal-title {
    font-weight: 700;
  }

  .ant-modal-footer .ant-btn {
    height: 34px;
    padding-inline: 16px;

    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    border-radius: 5px;
    border: none !important;

    font-size: 14px;
    font-weight: 700;
    font-family: "Inter";

    box-shadow: none !important;
    transition: transform 0.15s ease !important;

    &:hover,
    &:focus {
      transform: scale(1.03);
    }

    &:active {
      transform: scale(0.97);
    }
  }

  .ant-modal-footer .ant-btn-default,
  .ant-modal-footer .ant-btn-default:hover,
  .ant-modal-footer .ant-btn-default:focus,
  .ant-modal-footer .ant-btn-default:active,
  .ant-modal-footer .ant-btn-default:not(:disabled):active {
    background: ${BACK_BUTTON_BG} !important;
    border-color: ${BACK_BUTTON_BG} !important;
    color: ${BACK_BUTTON_COLOR} !important;
    box-shadow: none !important;
  }

  .ant-modal-footer .ant-btn-primary,
  .ant-modal-footer .ant-btn-primary:hover,
  .ant-modal-footer .ant-btn-primary:focus,
  .ant-modal-footer .ant-btn-primary:active,
  .ant-modal-footer .ant-btn-primary:not(:disabled):active {
    background: ${PRIMARY_BG} !important;
    border-color: ${PRIMARY_BG} !important;
    color: #fff !important;
    box-shadow: none !important;
  }

  .ant-modal-footer .ant-btn-primary.ant-btn-dangerous,
  .ant-modal-footer .ant-btn-primary.ant-btn-dangerous:hover,
  .ant-modal-footer .ant-btn-primary.ant-btn-dangerous:focus,
  .ant-modal-footer .ant-btn-primary.ant-btn-dangerous:active,
  .ant-modal-footer .ant-btn-primary.ant-btn-dangerous:not(:disabled):active {
    background: ${DANGER_BG} !important;
    border-color: ${DANGER_BG} !important;
    color: #fff !important;
    box-shadow: none !important;
  }
`;
